// src/components/ui/LanguageToggle.js
import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { useTheme } from '../../context/ThemeContext';

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();
  const { darkMode } = useTheme();
  
  return (
    <button
      onClick={toggleLanguage}
      className={`p-2 rounded-full ${
        darkMode 
          ? 'hover:bg-gray-700 text-gray-300' 
          : 'hover:bg-gray-200 text-gray-700'
      } transition-colors duration-200 flex items-center`}
      aria-label={language === 'fr' ? 'Switch to English' : 'Passer en français'}
    >
      <span className="font-medium text-sm">
        {language === 'fr' ? 'EN' : 'FR'}
      </span>
    </button>
  );
};

export default LanguageToggle;